export default __webpack_public_path__ + "static/772-7d1946de378bcf61deef906efae69259.gif";